/**
 * Created by lihib on 16-Nov-14.
 *
 */
define(function (require) {
    "use strict";

    var template = require("manager-templates/lpTagView.tmpl");
    var Button = require("ui/button/Button");
    var Marionette = require("marionette");

    var lpTagCode = require("!raw-loader!assets/data/lpTagCode.snippet");
    var GeneralUtilities = require("infra-util/GeneralUtilities");
    var DomUtilities = require("infra-util/DomUtilities");
    var Bubble = require("ui/bubble/Bubble");
    var KpContent = require("ui.components/kpContent/kpContent");
    var EVENT_PREFIX = "LPTag";

    var KP_ID = "manage-domains";

    var LpTagView = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        LpTagView = Marionette.ItemView.extend({

            template : template,
            className : "lptag",
            withUIComponents : true,

            ui : {
                warningAlreadyTaggedIcon : ".warning-already-tagged-icon",
                lptagTextContainer : ".tag-box-container",
                lptagText : ".tag-box-text-code",
                warningAlreadyTagText : ".warning-already-tag-text H4",
                warningAlreadyCheckagainLink : ".warning-already-checkagain-link",
                manageDomainsContainer : ".manage-domains-container",
                manageDomainsText : ".manage-domains-text",
                manageDomainsIcon : ".manage-domains-icon",
                doneButton : ".done-button",
                selectButton : ".select-button"
            },

            uiComponents : {
                doneButton : {
                    type : Button,
                    options : {
                        el : "view.ui.doneButton",
                        permutation : Button.PERMUTATION.BTN,
                        initState : Button.STATES.ENABLED,
                        tabindex : 1
                    },
                    events : {
                        click : "onCancel"
                    }
                },
                selectButton : {
                    type : Button,
                    options : {
                        el : "view.ui.selectButton",
                        permutation : Button.PERMUTATION.BTN_PRIMARY,
                        initState : Button.STATES.ENABLED,
                        tabindex : 1
                    },
                    events : {
                        click : "selectText"
                    }
                }
            },

            events : {
                "click div.tag-box-text-code" : "selectText",
                "click .js-help-video-click" : "openKnowledgePack",
                "mouseenter .manage-domains-text" : "_showManageDomainsBubble",
                "mouseleave .manage-domains-text" : "_closeManageDomainsBubble"
            },

            initialize : function (options) {
                this.vent = options.vent;
                this.sessionManager = options.sessionManager;
                this.domain = options.domain;
                this.manageDomainsModel = options.manageDomainsModel;
                this.listenTo(this, "page:closeButtonClick", this.onCancel); // for X
            },

            onRender : function () {
                this._setLptagText();
                //this.checkSiteTagged();
                if(this.manageDomainsModel) {
                    this.ui.manageDomainsContainer.removeClass("hide");
                    this._renderManageDomains();
                    this._manageDomainsIndication();
                }
            },

            _renderManageDomains: function(){
                this.uiComponents.host$.createAndRender("manageDomainsLink", {
                    type: Button,
                    options:{
                        el : "view.ui.manageDomainsText",
                        permutation : Button.PERMUTATION.BLUELINK,
                        initState : Button.STATES.ENABLED
                    },
                    events : {
                        click : "manageDomainsClick"
                    }
                });

            },

            _manageDomainsIndication: function(){
                if(this.manageDomainsModel && this.manageDomainsModel.get(this.manageDomainsModel.KEYS.ENABLED)) {
                    this.ui.manageDomainsIcon.removeClass("hide");
                }
            },

            _showManageDomainsBubble: function(){
               this._forceCloseManageDomainsBubble();
               this.uiComponents.host$.createAndRender("kpContent", {
                   type : KpContent,
                   options : {
                       content: LE.translator.translate("LEManager.manage.domains.tooltip"),
                       KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                       kpID: KP_ID
                   },
                   events: {
                       "click": "_closeManageDomainsBubble"
                   }
               });
                this.uiComponents.host$.createAndRender("manageDomainsBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.manageDomainsText,
                        contentView: this.uiComponents.kpContent,
                        showCloseButton: false,
                        align: Bubble.ALIGN.BOTTOM,
                        position: Bubble.POSITION.RIGHT
                    }
                });
            },

            _closeManageDomainsBubble: function(){
                if (this.uiComponents.manageDomainsBubble){
                    this.uiComponents.manageDomainsBubble.close(false);
                }
            },
            _forceCloseManageDomainsBubble: function(){
                if (this.uiComponents.manageDomainsBubble){
                    this.uiComponents.manageDomainsBubble.close(true);
                }
            },

            //TODO: update this legacy code if the warning box is ever used
            /*checkSiteTagged : function () {
                if (LE.rtDataManager.visitorCount.getWasVisited()) {
                    this.ui.warningAlreadyTaggedIcon.css("background-position", "0px 0px");
                    this.ui.warningAlreadyTagText.text(Translator.translate("LEFramework.Tag.setup.completed"));
                } else {
                    this.ui.warningAlreadyTaggedIcon.css("background-position", "-40px 0px");
                    this.ui.warningAlreadyTagText.text(Translator.translate("LEFramework.Verify.website.tag.setup"));
                }
            },*/

            onBeforeClose : function () {
                GeneralUtilities.unsetFocusOnElement(this.ui.lptagTextContainer);

                this.uiComponents.doneButton.close();
                this.uiComponents.selectButton.close();
                return true;
            },

            _setLptagText : function () {
                var lptagText = lpTagCode;
                lptagText = lptagText.replace("LPTAG.SITE", this.sessionManager.getAccountId());
                lptagText = lptagText.replace("LPTAG.DOMAIN", this.domain);
                this.ui.lptagText.text(lptagText);

                GeneralUtilities.setFocusOnElement(this.ui.lptagTextContainer);
            },

            selectText : function () {
                DomUtilities.selectItemText(this.ui.lptagTextContainer);
            },

            openKnowledgePack : function () {
                LE.logger.info("Need Help for tag deployment was clicked","LPTagView:openKnowledgePack");
                LE.vent.trigger("openKP", {fragment: "placing-the-liveengage"});
            },

            manageDomainsClick : function () {
                LEManager.router.navigate("manageDomains");
            },

            onCancel : function () {
                this.vent.trigger(EVENT_PREFIX + ":Close");
                return true;
            },

            onClose : function () {

            }

        });
    });

    return LpTagView;
});
